/* Verified email-link Browse signals. No identity is inferred for anonymous visitors.
 * Load in the head so the purpose-limited token is removed before other page scripts.
 * Shopify privacy contract: https://shopify.dev/docs/api/customer-privacy
 */
(function () {
  'use strict';
  if (window.__havjoyBrowseLoaded) return;
  window.__havjoyBrowseLoaded = true;
  var ENDPOINT = 'https://ordernotfound.com/events/browse';
  var STORAGE = 'hj_browse';
  var TTL = 30 * 24 * 60 * 60 * 1000;
  var DWELL = 5000;
  var pageURL = new URL(window.location.href);
  var incoming = pageURL.searchParams.getAll('hj_browse');
  var pending = incoming.length === 1 ? incoming[0] : '';
  var cleaned = incoming.length > 0;
  pageURL.searchParams.delete('hj_browse');
  // A discount landing may still carry the token inside its same-origin redirect.
  var redirect = pageURL.searchParams.get('redirect');
  if (redirect) {
    try {
      var destination = new URL(redirect, pageURL.origin);
      if (destination.origin === pageURL.origin && destination.searchParams.has('hj_browse')) {
        var nested = destination.searchParams.getAll('hj_browse');
        if (!pending && nested.length === 1) pending = nested[0];
        destination.searchParams.delete('hj_browse');
        pageURL.searchParams.set('redirect', destination.pathname + destination.search + destination.hash);
        cleaned = true;
      }
    } catch (_) { /* Invalid redirects cannot identify a subscriber. */ }
  }
  if (cleaned) window.history.replaceState(window.history.state, '', pageURL.pathname + pageURL.search + pageURL.hash);
  function plausible(value) { return typeof value === 'string' && /^[A-Za-z0-9_.-]{16,4096}$/.test(value); }
  if (!plausible(pending)) pending = '';
  var token = '', expiresAt = 0, timer = null, granted = false, sent = Object.create(null);
  var attributionStarted = false, attributionReady = null, attributionSettled = true, attributionController = null;
  var handleMatch = /^\/products\/([a-zA-Z0-9][a-zA-Z0-9_-]{0,254})\/?$/.exec(pageURL.pathname);
  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || typeof privacy.marketingAllowed !== 'function') return null;
      return privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) { return null; }
  }
  function stopTimer() { if (timer !== null) clearTimeout(timer); timer = null; }
  function forget() {
    token = ''; expiresAt = 0; stopTimer();
    if (attributionController) attributionController.abort();
    try { window.localStorage.removeItem(STORAGE); } catch (_) { /* Storage may be disabled. */ }
  }
  function active() {
    var permission = allowed();
    if (permission === null) return false;
    if (!permission) { if (granted) pending = ''; granted = false; forget(); return false; }
    if (!token) return false;
    if (expiresAt <= Date.now()) { forget(); return false; }
    return true;
  }
  function emit(kind) {
    if (sent[kind] || document.visibilityState !== 'visible' || !active()) return;
    if (!window.crypto || typeof window.crypto.randomUUID !== 'function') return;
    var body = {token: token, kind: kind, nonce: window.crypto.randomUUID(), consent: {analytics: true, marketing: true}};
    if (kind === 'product_viewed') body.handle = handleMatch[1];
    // Each document emits at most once per kind. The server deduplicates across documents.
    sent[kind] = true;
    if (kind === 'cart' || kind === 'checkout_started') stopTimer();
    fetch(ENDPOINT, {method: 'POST', credentials: 'omit', keepalive: true,
      headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)}).catch(function () {});
  }
  function schedule() {
    stopTimer();
    if (document.visibilityState !== 'visible' || !active()) return;
    if (/^\/cart\/?$/.test(pageURL.pathname)) emit('cart');
    if (handleMatch && !sent.product_viewed && !sent.cart && !sent.checkout_started) timer = setTimeout(function () { timer = null; emit('product_viewed'); }, DWELL);
  }
  function syncConsent() {
    var permission = allowed();
    if (permission === null) return;
    if (!permission) {
      if (granted) pending = '';
      granted = false; forget(); return;
    }
    granted = true;
    if (pending) {
      token = pending; pending = ''; expiresAt = Date.now() + TTL;
      try { window.localStorage.setItem(STORAGE, JSON.stringify({token: token, expiresAt: expiresAt})); } catch (_) {}
    } else if (!token) {
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORAGE));
        if (saved && plausible(saved.token) && Number.isFinite(saved.expiresAt) && saved.expiresAt > Date.now() && saved.expiresAt <= Date.now() + TTL) {
          token = saved.token; expiresAt = saved.expiresAt;
        } else forget();
      } catch (_) { forget(); }
    }
    schedule();
    if (active()) persistAttribution();
    document.dispatchEvent(new Event('havjoy:browse-consent-ready'));
  }
  document.addEventListener('havjoy:browse-forget', function () {
    pending = ''; forget();
  });
  document.addEventListener('havjoy:browse-identity', function (event) {
    var identity = event.detail || {};
    if (allowed() !== true || !plausible(identity.token) || !identity.token.startsWith('s1.') ||
        !Number.isFinite(identity.expiresAt) || identity.expiresAt <= Date.now()) return;
    pending = '';
    token = identity.token; expiresAt = Math.min(identity.expiresAt, Date.now() + TTL); granted = true;
    sent.product_viewed = false;
    try { window.localStorage.setItem(STORAGE, JSON.stringify({token:token, expiresAt:expiresAt})); } catch (_) {}
    schedule();
  });
  function persistAttribution() {
    if (attributionStarted) return;
    var query = pageURL.searchParams;
    if (query.get('hj_source') !== 'havjoy_browse_email' || query.get('hj_workflow_id') !== 'wf_hw26_browse') return;
    if (!/^browse_(2h|26h)$/.test(query.get('hj_step_id') || '')) return;
    var attributes = {};
    for (var key of ['source', 'workflow_id', 'event_id', 'step_id']) {
      var values = query.getAll('hj_' + key);
      if (values.length !== 1 || !/^[A-Za-z0-9_-]{1,120}$/.test(values[0])) return;
      attributes['havjoy_' + key] = values[0];
    }
    // Clear previous Welcome experiment credit when this later email is selected.
    attributes.havjoy_experiment_id = '';
    attributes.havjoy_variant = '';
    for (var utm of ['source', 'medium', 'campaign', 'content']) {
      var value = query.get('utm_' + utm) || '';
      if (/^[A-Za-z0-9_-]{0,120}$/.test(value)) attributes['havjoy_utm_' + utm] = value;
    }
    attributionStarted = true;
    attributionSettled = false;
    attributionController = new AbortController();
    var timeout = setTimeout(function () { attributionController.abort(); }, 8000);
    attributionReady = fetch('/cart/update.js', {method: 'POST', credentials: 'same-origin',
      signal: attributionController.signal, headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: attributes})
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart attribution update failed');
      return response.json();
    }).then(function (cart) {
      var verified = Object.keys(attributes).every(function (key) { return String((cart.attributes || {})[key] || '') === attributes[key]; });
      document.documentElement.dataset.havjoyEmailAttribution = verified ? 'verified' : 'unverified';
    }).catch(function () { document.documentElement.dataset.havjoyEmailAttribution = 'unverified'; })
      .finally(function () { clearTimeout(timeout); attributionSettled = true; attributionController = null; });
  }
  document.addEventListener('click', function (event) {
    if (attributionSettled || !attributionReady || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    var url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || (url.pathname === window.location.pathname && url.search === window.location.search)) return;
    event.preventDefault();
    var navigationTimer;
    var deadline = new Promise(function (resolve) { navigationTimer = setTimeout(resolve, 2000); });
    Promise.race([attributionReady, deadline]).then(function () {
      clearTimeout(navigationTimer);
      window.location.assign(url.href);
    });
  }, true);
  document.addEventListener('visitorConsentCollected', function () {
    // An explicit denial also discards a token awaiting first consent.
    if (allowed() === false) pending = '';
    syncConsent();
  });
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pagehide', stopTimer);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('a[href],button,input');
    if (!target || target.disabled || !target.getClientRects().length) return;
    var checkout = target.name === 'checkout';
    if (target.tagName === 'A') {
      try { var url = new URL(target.href, pageURL.origin); checkout = url.origin === pageURL.origin && /^\/checkout(?:\/|$)/.test(url.pathname); } catch (_) {}
    }
    if (checkout) emit('checkout_started');
  }, true);
  document.addEventListener('submit', function (event) {
    var button = event.submitter;
    var form = event.target;
    var url;
    try { url = new URL(form.action, pageURL.origin); } catch (_) { return; }
    if (!event.defaultPrevented && isCartAdd(form.method, form.action)) emit('cart');
    if ((button && button.name === 'checkout') || (url.origin === pageURL.origin && /^\/checkout(?:\/|$)/.test(url.pathname))) emit('checkout_started');
  }, true);
  function isCartAdd(method, path) {
    try {
      var url = new URL(path, window.location.href);
      return String(method || 'GET').toUpperCase() === 'POST' && url.origin === window.location.origin && /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }
  // Shopify drawer carts often stay on the product page. Observe successful cart
  // additions without reading bodies, consuming responses, or delaying requests.
  var originalFetch = window.fetch;
  window.fetch = function (input, options) {
    var promise = originalFetch.apply(this, arguments);
    var request = typeof Request !== 'undefined' && input instanceof Request;
    var method = options && options.method || (request ? input.method : 'GET');
    var path = request ? input.url : input;
    if (isCartAdd(method, path)) promise.then(function (response) {
      if (response.ok) { try { emit('cart'); } catch (_) {} }
    }, function () {});
    return promise;
  };
  var xhrCartRequests = new WeakMap();
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, path) {
    var result = originalOpen.apply(this, arguments);
    xhrCartRequests.set(this, isCartAdd(method, path));
    return result;
  };
  XMLHttpRequest.prototype.send = function () {
    if (xhrCartRequests.get(this)) this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300) { try { emit('cart'); } catch (_) {} }
    }, {once: true});
    return originalSend.apply(this, arguments);
  };
  var loadingPrivacy = false;
  function initializePrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) { syncConsent(); return; }
    if (!loadingPrivacy && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loadingPrivacy = true;
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        loadingPrivacy = false;
        if (!error) syncConsent();
      });
    }
  }
  initializePrivacy();
  // The head installer scrubs tokens before Shopify and third-party scripts run.
  // Shopify may not expose loadFeatures until its own bootstrap has executed.
  document.addEventListener('DOMContentLoaded', initializePrivacy, {once: true});
  window.addEventListener('load', initializePrivacy, {once: true});
})();
